{
  "notFound": {
    "title": "Page non trouvée",
    "description": "Désolé, la page que tu cherches n’existe pas."
  },
  "fatalError": {
    "title": "La configuration de l'application a échoué.",
    "description": "Veuillez essayer de rafraîchir la page."
  },
  "buttons": {
    "back": "Retour",
    "cancel": "Annuler",
    "validate": "Valider"
  },
  "profile": {
    "title": "Profil",
    "subtitle": "Informations du profil",
    "logout": "Déconnexion",
    "language": "Langue",
    "settings": "Paramètres",
    "administration": "Administration",
    "userManagement": "Gestion des utilisateurs",
    "selectLanguage": "Sélectionner la langue",
    "logoutDialog": {
      "title": "Se déconnecter ?",
      "description": "Tous vos rapports seront sauvegardés et récupérables lors de votre prochaine connexion"
    },
    "personalInformation": {
      "title": "Informations personnelles",
      "fields": {
        "lastName": "Nom",
        "firstName": "Prénom",
        "email": "Email",
        "country": "Pays",
        "organization": "Organisation"
      }
    }
  },
  "board": {
    "title": "Santé mondiale de la faune sauvage"
  },
  "navigation": {
    "board": "Accueil",
    "myReports": "Mes Rapports",
    "addReport": "Nouveau Rapport",
    "resources": "Ressources",
    "alerts": "Alertes",
    "userManagement": "Gestion des utilisateurs",
    "profile": "Profil",
    "appTitle": "WildEpi",
    "map": "Carte",
    "list": "Liste"
  },
  "alerts": {
    "markAllAsRead": "Marquer tout comme lu",
    "updateOnReport": "Mise à jour du rapport",
    "reportUpdated": "{{reportCode}} a été mis à jour",
    "savedOnReport": "Enregistrement du rapport",
    "reportSaved": "{{reportCode}} a été enregistré",
    "rraRequestedOnReport": "Demande RRA sur le rapport",
    "reportRraRequested": "Une RRA a été demandée pour {{reportCode}}",
    "rraCompletedOnReport": "RRA terminée sur le rapport",
    "reportRraCompleted": "La RRA est terminée pour {{reportCode}}",
    "draftOnReport": "Brouillon du rapport",
    "reportDraft": "{{reportCode}} a été enregistré en brouillon",
    "emptyTitle": "Aucune alerte pour le moment"
  },
  "resources": {
    "learningMaterial": "Support d'apprentissage",
    "helpAndSupport": "Aide et support",
    "trainingVideos": "Tutoriels vidéos",
    "about": "A propos",
    "faqs": "FAQ",
    "reportBug": "Signaler un bug ou un problème"
  },
  "app": {
    "name": "WildEpi"
  },
  "login": {
    "sso": "Connexion SSO",
    "welcome": "Bienvenue sur WildEpi"
  },
  "auth": {
    "userLoadError": {
      "title": "Impossible de charger votre profil",
      "description": "Veuillez réessayer pour continuer à utiliser l'application."
    },
    "retry": "Réessayer",
    "loadingProfile": "Chargement de votre profil..."
  },
  "offlineMode": {
    "banner": "Vous êtes hors ligne. Seule la création de rapport est disponible."
  },
  "noData": "Pas de donnée trouvé",
  "reportCreation": {
    "title": "Créer un rapport",
    "editTitle": "Modifier un rapport",
    "backToReport": "Retour au rapport",
    "steps": {
      "generalInformation": "Informations générales",
      "surveillanceAndEtiology": "Surveillance et étiologie",
      "diagnosticProcedure": "Procédure diagnostique",
      "supportingDocuments": "Documents justificatifs"
    },
    "buttons": {
      "saveAsDraft": "Sauvegarder brouillon",
      "deleteDraft": "Supprimer le brouillon",
      "next": "Suivant",
      "save": "Enregistrer",
      "publish": "Publier"
    },
    "success": {
      "title": "Votre rapport a été publié",
      "subtitle": "Modifiez-le à tout moment et retrouvez-le dans Mes rapports.",
      "validateButton": "Valider",
      "draftTitle": "Votre rapport a été enregistré en brouillon",
      "draftSubtitle": "Ce rapport a été enregistré en brouillon. Vous pouvez le retrouver dans votre liste de rapports.",
      "queuedTitle": "Votre rapport est en attente de synchronisation",
      "queuedSubtitle": "Nous l'enverrons automatiquement dès que la connexion sera disponible.",
      "csvImportPublishedTitle": "Vos rapports sont en cours de synchronisation",
      "csvImportPublishedSubtitle": "Ils seront visibles dans Mes rapports dès que la synchronisation sera terminée.",
      "csvImportDraftTitle": "Vos rapports sont en cours de synchronisation",
      "csvImportDraftSubtitle": "Les lignes valides seront publiées. Les lignes invalides seront enregistrées en brouillon pour être finalisées plus tard.",
      "csvImportResultTitle": "Import CSV terminé",
      "csvImportResultSubtitle": "Résultat de l'import de vos rapports.",
      "csvImportResultPublished": "{{count}} rapport(s) publié(s)",
      "csvImportResultDraft": "{{count}} rapport(s) en brouillon",
      "csvImportResultError": "{{count}} rapport(s) en erreur"
    },
    "toasts": {
      "submitError": "Une erreur est survenue lors de l'enregistrement du rapport. Veuillez réessayer.",
      "uploadSupportingDocumentsError": "Une erreur est survenue lors de l'envoi des documents justificatifs. Veuillez réessayer.",
      "similarReportsMissingLocation": "Veuillez renseigner des coordonnées valides avant de publier.",
      "similarReportsError": "Impossible de vérifier les rapports similaires. Veuillez réessayer.",
      "offlineQueueAdded": "Rapport ajouté à la file d'envoi hors ligne.",
      "offlineQueueProcessed": "Les rapports en attente ont été synchronisés."
    },
    "similarReports": {
      "title": "Valider le rapport",
      "heading": "Nous avons trouvé des rapports similaires",
      "subheading": "Veuillez vérifier les rapports suivants avant de publier."
    },
    "versionNote": {
      "title": "Ajouter une note de version",
      "heading": "Ajouter une note de version",
      "fieldLabel": "Note de version",
      "placeholder": "Décrivez la raison de la modification"
    },
    "deleteDraftDialog": {
      "title": "Supprimer le brouillon ?",
      "description": "Ce brouillon sera supprimé et toutes les informations saisies seront perdues.",
      "confirm": "Supprimer le brouillon"
    },
    "creationModeModal": {
      "title": "Ajouter un rapport",
      "description": "Choisissez un type de création de rapport",
      "inAppForm": "Formulaire dans l'app",
      "csvImport": "Import CSV"
    },
    "csvImportModal": {
      "title": "Import CSV",
      "dropzoneTitle": "Cliquez pour ajouter un fichier",
      "dropzoneSubtitle": "Format CSV (15 Mo max.)",
      "back": "Retour",
      "import": "Importer",
      "saveAsDraft": "Enregistrer en brouillon",
      "publish": "Publier",
      "downloadTemplate": "Télécharger le modèle"
    },
    "csvImportValidation": {
      "file": "Fichier",
      "errorRowLabel": "Ligne {{rowNumber}} - {{columnHeader}}",
      "summary": {
        "valid": "Validation réussie. {{totalRows}} ligne(s) prêtes à l'import.",
        "invalid": "Validation échouée. {{validRows}} valide(s) / {{invalidRows}} invalide(s) sur {{totalRows}}."
      },
      "errors": {
        "noFileSelected": "Veuillez sélectionner un fichier CSV avant d'importer.",
        "unableToReadFile": "Impossible de lire le fichier sélectionné.",
        "emptyFile": "Le fichier CSV est vide.",
        "noDataRows": "Aucune ligne de données trouvée. Ajoutez au moins une ligne de rapport.",
        "missingColumn": "Colonne manquante dans l'en-tête CSV.",
        "unexpectedColumn": "Colonne inattendue dans l'en-tête CSV.",
        "requiredField": "Ce champ est requis.",
        "invalidOption": "La valeur ne correspond pas aux valeurs autorisées.",
        "invalidDynamicOption": "La valeur ne correspond pas aux valeurs autorisées pour ce parent.",
        "invalidDate": "Date invalide. Format attendu : AAAA-MM-JJ ou JJ/MM/AAAA.",
        "invalidNumber": "Nombre invalide.",
        "numberBelowZero": "La valeur doit être supérieure ou égale à 0.",
        "populationMustBeAboveZero": "La taille de la population doit être supérieure à 0.",
        "invalidLatitude": "La latitude doit être comprise entre -90 et 90.",
        "invalidLongitude": "La longitude doit être comprise entre -180 et 180.",
        "totalCountTooLow": "Le nombre total de tests doit être au moins égal aux tests positifs + négatifs.",
        "textTooLong": "Le texte dépasse la longueur maximale ({{count}} caractères)."
      }
    },
    "csvTemplate": {
      "diagnosticPrefix": "Diagnostic",
      "hints": {
        "dynamicOptionExactMatch": "Sélectionnez une valeur dans la liste de l'app (le texte doit correspondre exactement).",
        "species": "Saisissez le nom scientifique de l'espèce (nom exact).",
        "yesNo": "Oui | Non",
        "date": "Format de date : AAAA-MM-JJ",
        "nonNegativeNumber": "Nombre >= 0",
        "populationSize": "Nombre > 0 et au moins égal à morts + malades.",
        "totalCount": "Nombre >= tests positifs + tests négatifs.",
        "maxCharacters_one": "Texte libre (max {{count}} caractère).",
        "maxCharacters_other": "Texte libre (max {{count}} caractères).",
        "freeText": "Texte libre",
        "latitude": "Latitude décimale (WGS84).",
        "longitude": "Longitude décimale (WGS84)."
      }
    },
    "errors": {
      "requiredField": "Ce champ est requis",
      "countryForbidden": "Vous ne pouvez pas créer de rapports dans ce pays.",
      "noCountryCoordinates": "Aucun pays n'est associé à ces coordonnées.",
      "futureDetectionDate": "La date de détection ne peut pas être postérieure à aujourd'hui.",
      "populationMustBeGreaterThanZero": "La taille de la population doit être supérieure à 0.",
      "populationTooSmall": "La taille de la population doit être au moins égale au total des malades et des morts.",
      "testsMustBeNonNegative": "Le nombre de tests doit être supérieur ou égal à 0.",
      "testsGreaterThanPopulation": "Le nombre de tests ne peut pas dépasser la taille de la population.",
      "totalTestsTooLow": "Le nombre total de tests doit être au moins la somme des positifs et négatifs.",
      "totalTestsMustBeGreaterThanZero": "Le nombre total de tests doit être supérieur à 0.",
      "wahisAgentInWahis": "Cet agent étiologique est géré dans l'application WAHIS. Veuillez le déclarer depuis WAHIS."
    },
    "common": {
      "characterLimit": "{{currentLength}}/{{maxLength}} caractères max",
      "noResults": "Aucun résultat",
      "useCustomValue": "Utiliser \"{{value}}\" comme valeur personnalisée"
    },
    "step1": {
      "sections": {
        "animalDescription": "Description de l'animal",
        "location": "Localisation - WGS84",
        "dateOfDetection": "Date de détection"
      },
      "fields": {
        "animalType": "Type d'animal",
        "species": "Espèce",
        "wildtype": "Type sauvage",
        "location": "Localisation",
        "dateOfDetection": "Date de détection",
        "inaccurateLocation": "Localisation approximative"
      },
      "placeholders": {
        "selectSpecies": "Sélectionner une espèce ou un groupe",
        "speciesFreeText": "Saisissez une espèce",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "dateFormat": "DD/MM/YYYY"
      },
      "options": {
        "animalType": {
          "vertebrate": "Vertébré",
          "invertebrate": "Invertébré"
        },
        "wildtype": {
          "freeRoaming": "En liberté",
          "captive": "Captif",
          "feral": "Féral"
        },
        "species": {
          "canisLupus": "Canis lupus",
          "bosTaurus": "Bos taurus",
          "susScrofa": "Sus scrofa",
          "anasPlatyrhynchos": "Anas platyrhynchos",
          "apisMellifera": "Apis mellifera"
        }
      }
    },
    "step2": {
      "sections": {
        "surveillance": "Surveillance",
        "etiology": "Étiologie"
      },
      "fields": {
        "surveillanceType": "Type de surveillance",
        "description": "Description",
        "numberOfDeaths": "Nombre d'individus morts",
        "numberOfSick": "Nombre d'individus malades",
        "populationSize": "Taille de la population (si connue)",
        "humanAffected": "Humain atteint",
        "domesticAnimalAffected": "Animal domestique atteint",
        "knowTheCause": "Connaissez-vous la cause ?",
        "etiologyType": "Type d'étiologie",
        "etiologyAgent": "Agent étiologique",
        "diagnosticProcedure": "Procédure diagnostique"
      },
      "placeholders": {
        "describeSurveillance": "Décrire la surveillance",
        "selectEtiologyType": "Sélectionner le type d'étiologie",
        "selectEtiologyAgent": "Sélectionner un agent étiologique"
      },
      "options": {
        "surveillanceType": {
          "active": "Active",
          "passive": "Passive",
          "other": "Autre",
          "unknown": "Inconnu"
        },
        "yesNoUnknown": {
          "yes": "Oui",
          "no": "Non",
          "iDontKnow": "Je ne sais pas"
        },
        "yesNo": {
          "yes": "Oui",
          "no": "Non"
        },
        "diagnosticProcedure": {
          "yes": "Oui",
          "no": "Non"
        }
      },
      "helpers": {
        "etiologyAgentHint": "Si votre agent n'est pas dans la liste, veuillez le saisir ici pour l'ajouter."
      },
      "warnings": {
        "massMortality": "Message d'avertissement : vous signalez un événement de mortalité ou de morbidité massive. Le nombre d'animaux atteints est-il correct ?"
      }
    },
    "step3": {
      "diagnosticProcedureTitle": "Procédure diagnostique",
      "sections": {
        "sampling": "Échantillonnage",
        "tests": "Tests",
        "results": "Résultats"
      },
      "fields": {
        "sampleType": "Type d'échantillon",
        "category": "Catégorie",
        "subcategory": "Sous-catégorie",
        "family": "Famille",
        "positiveCount": "Nombre de tests positifs",
        "negativeCount": "Nombre de tests négatifs",
        "totalCount": "Nombre total de tests",
        "extraTestInfo": "Informations complémentaires sur le test"
      },
      "placeholders": {
        "sampleType": "Rechercher un type d'échantillon",
        "subcategory": "Sélectionner une sous-catégorie",
        "family": "Sélectionner une famille",
        "extraTestInfo": "Décrire les informations de test"
      },
      "options": {
        "category": {
          "direct": "Direct",
          "indirect": "Indirect",
          "observation": "Observation",
          "others": "Autres"
        },
        "subcategory": {
          "pcr": "PCR",
          "microscopy": "Microscopie",
          "serology": "Sérologie",
          "fieldObservation": "Observation de terrain"
        },
        "family": {
          "viralIsolation": "Isolement viral",
          "genomicSequencing": "Séquençage génomique",
          "elisa": "ELISA",
          "rapidTest": "Test rapide"
        }
      },
      "actions": {
        "addProcedure": "Ajouter un test",
        "addButtonSectionTitle": "Avez-vous réalisé des tests supplémentaires ?",
        "deleteProcedure": "Supprimer le test"
      }
    },
    "step4": {
      "sections": {
        "attachments": "Pièces jointes"
      },
      "fields": {
        "attachDocuments": "Joindre des documents"
      },
      "helpers": {
        "tapToAddFile": "Appuyez pour ajouter un fichier",
        "fileFormats": "Formats PDF, DOCX, CSV, PNG, TXT ou JPEG (15 Mo max.)"
      },
      "errors": {
        "unsupportedFormat": "Certains fichiers n'ont pas été ajoutés car leur format n'est pas pris en charge.",
        "sizeExceeded": "Certains fichiers dépassent la limite de 15 Mo et ont été ignorés."
      }
    }
  },
  "reportDetail": {
    "title": "Détails du rapport",
    "header": {
      "author": "Auteur",
      "creationDate": "Date de création",
      "country": "Pays",
      "version": "Version"
    },
    "sections": {
      "generalInformation": "Informations générales",
      "surveillanceAndEtiology": "Surveillance et étiologie",
      "diagnosticProcedure": "Procédure diagnostique",
      "supportingDocuments": "Documents justificatifs",
      "rapidRiskAssessment": "Évaluation rapide des risques (RRA)"
    },
    "fields": {
      "speciesAndOrder": "Espèce et ordre",
      "locationCoordinates": "Localisation (latitude / longitude)",
      "locationAccuracyFlag": "Indicateur de précision de localisation"
    },
    "missingIndicator": "À compléter",
    "diagnosticProcedureLabel": "Procédure diagnostique {{index}}",
    "supportingDocuments": {
      "empty": "Aucun document justificatif.",
      "fileType": "Type",
      "fileSize": "Taille",
      "uploadDate": "Date de téléversement"
    },
    "toasts": {
      "openSupportingDocumentError": "Impossible d’ouvrir le document justificatif. Veuillez réessayer.",
      "loadVersionsError": "Impossible de charger les versions du rapport. Veuillez réessayer.",
      "shareError": "Impossible de partager le lien du rapport. Veuillez réessayer.",
      "copyShareUrlSuccess": "Lien du rapport copié.",
      "copyShareUrlError": "Impossible de copier le lien du rapport. Veuillez réessayer.",
      "requestRraError": "Impossible de demander une RRA. Veuillez réessayer.",
      "uploadRraError": "Impossible d’importer le document RRA. Veuillez réessayer."
    },
    "versions": {
      "title": "Versions du rapport",
      "versionLabel": "v. {{version}}"
    },
    "actions": {
      "edit": "Modifier",
      "delete": "Supprimer",
      "requestRra": "Demander RRA",
      "uploadRra": "Importer la RRA",
      "download": "Télécharger",
      "open": "Ouvrir",
      "share": "Partager",
      "copyShareUrl": "Copier le lien du rapport"
    },
    "share": {
      "title": "Partager le rapport"
    },
    "deleteDialog": {
      "title": "Supprimer le rapport ?",
      "description": "Ce rapport sera supprimé de votre liste."
    },
    "rra": {
      "pendingState": "RRA en attente",
      "pendingDescription": "Le fichier sera visible ici lorsqu’il sera publié",
      "pdfLabel": "Document RRA",
      "versionNote": "Document RRA importé"
    },
    "rraRequestSuccess": {
      "title": "Votre demande d’évaluation rapide des risques a été envoyée",
      "subtitle": "Une fois le statut mis à jour, vous pourrez consulter le PDF dans les détails du rapport.",
      "validateButton": "Aller au rapport"
    },
    "values": {
      "yes": "Oui",
      "no": "Non",
      "dontKnow": "Je ne sais pas"
    }
  },
  "speciesSearch": {
    "title": "Espèces",
    "searchPlaceholder": "Rechercher une espèce ou un groupe taxonomique",
    "actions": {
      "taxonomyTree": "Arbre de taxonomie",
      "identifyWithAi": "Identifier par IA"
    },
    "results": {
      "title": "Résultats de recherche"
    },
    "empty": {
      "noResults": "Aucun résultat",
      "promptTitle": "Rechercher une espèce",
      "promptDescription": "Commencez à saisir pour voir des espèces ou groupes taxonomiques."
    },
    "ai": {
      "title": "Identifier par IA",
      "imagePreviewTitle": "Aperçu de l'image",
      "previewDescription": "Nous utiliserons ce fichier pour identifier l'espèce.",
      "processingTitle": "Analyse de l'espèce en cours...",
      "processingDescription": "Veuillez patienter quelques secondes pendant l'analyse de votre fichier.",
      "noResultsTitle": "Aucune correspondance trouvée",
      "noResultsDescription": "Nous n'avons pas pu identifier l'espèce à partir de ce fichier.",
      "matchesTitle": "Nous avons trouvé {{count}} espèces correspondantes",
      "matchesSubtitle": "Sélectionnez une espèce pour continuer",
      "bestMatch": "Meilleure correspondance",
      "otherMatches": "Autres correspondances",
      "wrongGuess": "Mauvaise suggestion ?",
      "trySearch": "Faire une recherche",
      "emptyTitle": "Aucun résultat pour le moment",
      "emptyDescription": "Prenez ou importez une image pour identifier l'espèce."
    },
    "modals": {
      "addFileTitle": "Ajouter un fichier",
      "photoLibrary": "Photothèque",
      "takePhoto": "Prendre une photo",
      "chooseFile": "Choisir un fichier"
    },
    "taxonomy": {
      "title": "Arbre de taxonomie",
      "select": "Sélectionner {{level}}",
      "helperPrefix": "Vous ne savez pas ?",
      "helperSearch": "Essayez une recherche",
      "helperConnector": "ou",
      "stopIdentification": "arrêter l'identification",
      "loading": "Chargement de la taxonomie...",
      "noResults": "Aucun résultat de taxonomie.",
      "noResultsForSelection": "Aucun résultat pour \"{{label}}\".",
      "emptyTitle": "Aucune donnée de taxonomie",
      "emptyDescription": "L'arbre de taxonomie s'affichera ici.",
      "unassigned": "Non assigné"
    }
  },
  "reports": {
    "count": "{{count}} rapports",
    "emptyStateDescription": "Une fois soumis, votre rapport apparaîtra ici.",
    "emptyStateTitle": "Aucun rapport pour le moment",
    "individuals": "individus",
    "action": {
      "viewMore": "Plus de détails"
    },
    "loadingMore": "Chargement de rapports supplémentaires...",
    "exportCsv": "Exporter",
    "csvExport": {
      "headers": {
        "reportCode": "Code du rapport",
        "versionNumber": "Numéro de version",
        "userCountry": "Pays de l'utilisateur",
        "userOrganization": "Organisation de l'utilisateur",
        "assets": "Pièces jointes",
        "diagnosticSampleType": "Diagnostic {{index}} - Type d'échantillon",
        "diagnosticSubcategory": "Diagnostic {{index}} - Sous-catégorie",
        "diagnosticCategoryOfTest": "Diagnostic {{index}} - Catégorie de test",
        "diagnosticFamily": "Diagnostic {{index}} - Famille",
        "diagnosticExtraTestInformation": "Diagnostic {{index}} - Informations complémentaires sur le test",
        "diagnosticNumberOfNegativeTests": "Diagnostic {{index}} - Nombre de tests négatifs",
        "diagnosticNumberOfPositiveTests": "Diagnostic {{index}} - Nombre de tests positifs",
        "diagnosticNumberOfTests": "Diagnostic {{index}} - Nombre de tests"
      }
    },
    "pageSize": "Éléments par page",
    "sort": {
      "none": "Aucun tri",
      "placeholder": "Trier par",
      "order": "Changer l'ordre de tri"
    },
    "columns": {
      "species": "Espèce",
      "disease": "Maladie",
      "individualsAffected": "Individus atteints",
      "dateOfDetection": "Date de détection",
      "location": "Localisation",
      "status": "Statut"
    }
  },
  "filters": {
    "title": "Filtres",
    "apply": "Appliquer",
    "clear": "Effacer",
    "close": "Fermer les filtres",
    "open": "Filtrer",
    "sections": {
      "generalInformation": "Informations générales",
      "animal": "Animal",
      "surveillanceAndEtiology": "Surveillance et étiologie",
      "diagnosticProcedure": "Procédure diagnostique"
    },
    "fields": {
      "reportName": "Nom du rapport",
      "status": "Statut",
      "country": "Pays",
      "region": "Région",
      "dateOfDetection": "Date de détection",
      "animalType": "Type",
      "order": "Ordre",
      "species": "Espèce",
      "wildType": "Type sauvage",
      "surveillanceType": "Type de surveillance",
      "knownCause": "Connaissance de la cause",
      "etiologyType": "Type d’étiologie",
      "etiologicalAgent": "Agent étiologique",
      "diagnosticProcedure": "Procédure diagnostique",
      "sampleType": "Type d’échantillon",
      "categoryOfTest": "Type de test"
    },
    "placeholders": {
      "reportName": "Tous les noms de rapport",
      "status": "Tous les statuts",
      "country": "Tous les pays",
      "region": "Toutes les régions",
      "dateRange": "Toutes les dates",
      "order": "Tous les ordres",
      "species": "Toutes les espèces",
      "wildType": "Tous les types sauvages",
      "surveillanceType": "Tous les types",
      "etiologyType": "Tous les types",
      "etiologicalAgent": "Tous les agents",
      "sampleType": "Tous les types",
      "categoryOfTest": "Tous les types"
    },
    "options": {
      "all": "Tous",
      "status": {
        "published": "Publié",
        "pendingRra": "RRA en attente",
        "publishedRra": "RRA publiée",
        "draft": "Brouillon",
        "incorrect": "Incorrect"
      }
    },
    "dateRange": {
      "start": "Début",
      "end": "Fin",
      "today": "Aujourd'hui"
    }
  },
  "pinPosition": {
    "selectLocation": "Sélectionner l'emplacement",
    "longitude": "Longitude",
    "latitude": "Latitude",
    "modalTitle": "Emplacement de l'animal/échantillon",
    "coordinatesTitle": "Coordonnées WGS84"
  },
  "userManagement": {
    "title": "Gestion des utilisateurs",
    "actions": {
      "add": "Ajouter un utilisateur",
      "edit": "Modifier",
      "delete": "Supprimer",
      "deactivate": "Désactiver l'utilisateur",
      "save": "Enregistrer"
    },
    "columns": {
      "name": "Nom",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "country": "Pays",
      "organization": "Organisation",
      "role": "Rôle",
      "status": "Statut",
      "creationDate": "Date de création",
      "actions": "Actions"
    },
    "filters": {
      "allCountries": "Tous les pays",
      "allRoles": "Tous les rôles",
      "allStatuses": "Tous les statuts",
      "country": "Pays",
      "role": "Rôle",
      "status": "Statut"
    },
    "search": {
      "label": "Recherche",
      "placeholder": "Rechercher par nom ou email"
    },
    "roles": {
      "basic": "Basique",
      "validated": "Validé",
      "focalPoint": "Point focal",
      "delegate": "Délégué",
      "referenceCenter": "Centre de référence",
      "adminViewOnly": "Admin (lecture seule)",
      "admin": "Admin"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "form": {
      "fullName": "Nom complet",
      "firstName": "Prénom",
      "lastName": "Nom",
      "organization": "Organisation",
      "email": "Email",
      "country": "Pays",
      "role": "Rôle",
      "fullNamePlaceholder": "Saisir le nom complet",
      "firstNamePlaceholder": "Saisir le prénom",
      "lastNamePlaceholder": "Saisir le nom",
      "organizationPlaceholder": "Saisir l'organisation",
      "emailPlaceholder": "Saisir l'adresse email",
      "countryPlaceholder": "Sélectionner un pays",
      "rolePlaceholder": "Sélectionner un rôle"
    },
    "errors": {
      "required": "Ce champ est obligatoire",
      "email": "Saisissez une adresse email valide"
    },
    "modal": {
      "createTitle": "Ajouter un utilisateur",
      "editTitle": "Modifier un utilisateur",
      "createDescription": "Renseignez les informations ci-dessous.",
      "editDescription": "Mettez à jour les informations ci-dessous.",
      "discardTitle": "Annuler les modifications ?",
      "discardDescription": "Vos modifications seront perdues.",
      "discard": "Ignorer"
    },
    "deleteDialog": {
      "title": "Désactiver l'utilisateur ?",
      "description": "Cela désactivera l'utilisateur et retirera son accès."
    },
    "empty": {
      "list": "Aucun utilisateur trouvé.",
      "country": "Aucun pays",
      "date": "Aucune date"
    },
    "loading": "Chargement des utilisateurs...",
    "noAccess": {
      "title": "Accès restreint",
      "description": "Vous n'avez pas l'autorisation d'accéder à la gestion des utilisateurs."
    }
  }
}
